import Splide from '@splidejs/splide';

export default {

	selectors: {
		splide: '.carousel-splide',
		counter: '.splide__counter',
	},

	init() {
		if (!document.querySelectorAll(this.selectors.splide).length) return;

		const carousels = Array.from(document.querySelectorAll(this.selectors.splide));

		carousels.forEach((carousel) => {
			const splide = new Splide(carousel, {
				arrows: false,
				pagination: false,
			});

			const counter = carousel.querySelector(this.selectors.counter);

			splide.on('mounted', () => {
				if (counter) {
					counter.textContent = `${splide.index + 1}/${splide.length}`;
				}
			});

			splide.on('move', (slide) => {
				if (counter) {
					counter.textContent = `${slide + 1}/${splide.length}`;
				}
			});

			splide.mount();
		});
	},

};
